import { FC, useEffect, useState } from 'react';

import './promoCodeScratcherStyles.scss';

interface PromoCodeScratcherProps {
	promoCodeScratched?: boolean;
	setPromoCodeScratched?: (value: boolean) => void;
}

export const PromoCodeScratcher: FC<PromoCodeScratcherProps> = ({ promoCodeScratched, setPromoCodeScratched }) => {
	const [scratchCode, setScratchCode] = useState<number>(promoCodeScratched ? 3 : 0);

	useEffect(() => {
		if (scratchCode === 3 && setPromoCodeScratched) {
			setPromoCodeScratched(true);
		}
	}, [scratchCode, setPromoCodeScratched]);

	const onTouchMove = () => {
		if (scratchCode < 3) {
			setTimeout(() => {
				setScratchCode(scratchCode + 1);
			}, 200);
		}
	};

	const getOpacity = () => {
		switch (scratchCode) {
			case 0:
				return 1;
			case 1:
				return 0.6;
			case 2:
				return 0.3;
			case 3:
				return 0;
		}
	};

	const onScratch = () => {
		if (scratchCode < 3) {
			setScratchCode(scratchCode + 1);
		}
	};

	return (
		<div className="relative">
			<div style={{ opacity: getOpacity() }} className="ScratchWrapper Wrapper" onClick={onScratch} onTouchMove={onTouchMove}>
				ZDRAP SWÓJ KOD
			</div>
			<div className="Scratched ScratchWrapper">BETFAN</div>
		</div>
	);
};
